<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component>
    <div class="modal-header">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 class="modal-title" modal-title>
        {{cfetLabels.cfet_affiliation_code.modal_title}}
      </h2>
      <div class="corner-button">
        <button type="button" class="close-modal-button" [attr.aria-label]="'Close'" tabindex="0"
          (click)="close($event, 'openModal')">
          <em aria-label="Close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" modal-content>
      <div class="row">
        <div class="col-md-12">
          <p>{{cfetLabels.cfet_affiliation_code.modal_desc}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="button" (click)="close($event,'openModal')" id="btn-ok" class="btn btn-alt btn-medium"
            tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.ok}}</button>
        </div>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>